
// Azure AD stores names as "First Last | Organization (tag)" — strip org suffix for Chakra Avatar initials.
export function sanitizeNameForInitials(name: string): string {
  return name.split('|')[0].trim()
}

// App-protocol links wrap a plain web URL behind a handler scheme so the link
// opens in a desktop app — OneNote citations are `onenote:https://…`. Strip the
// wrapper before parsing: `new URL('onenote:https://host/x')` has no hostname,
// so domain/favicon/page helpers would otherwise come up empty.
const APP_PROTOCOL_PREFIX = /^[a-z][a-z0-9+.-]*:(?=https?:\/\/)/i

export function toWebUrl(href: string): string {
  return href.replace(APP_PROTOCOL_PREFIX, '')
}

// Citation URLs deep-link to a PDF page via a `#page=N` fragment; pull the page
// out so callers can render a label without depending on a separate field.
export function getPageNumber(href: string): number | null {
  try {
    const pageMatch = new URL(toWebUrl(href)).hash.match(/#page=(\d+)/)
    return pageMatch ? parseInt(pageMatch[1], 10) : null
  } catch {
    return null
  }
}

export function formatDate(dateString: string) {
  const date = new Date(dateString)
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return date.toLocaleString(navigator.language || 'nl-NL', {
    timeZone: userTimeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
